// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"0ed252f31469ea56bd39","293":"09a8ffe5a16e84cb84c5"}[chunkId] + ".js";
};